import { createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import { checkbox } from '@tecsinapse/cortex-core'
import { Funcionalidade } from '@/core/types/graphql'
import { t } from '@lingui/core/macro'

const columnHelper = createColumnHelper<Funcionalidade>()

const formatNomeTipoAcesso = (nome: string) => {
  if (nome && nome.includes(' - ')) {
    return nome.split(' - ')[0]
  }

  return nome
}

export const columns = (
  updateSelectedFuncionalidades: (newFuncionalidades: Funcionalidade[]) => void,
  addFuncionalidade: (funcionalidade: Funcionalidade) => void,
  removeFuncionalidade: (funcionalidade: Funcionalidade) => void
) => {
  return [
    columnHelper.display({
      id: 'checkbox',
      header: ({ table }) => {
        const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
          const isChecked = e.target.checked
          table.toggleAllRowsSelected(isChecked)
          const selectedItems = isChecked
            ? table.getRowModel().rows.map(row => row.original)
            : []
          updateSelectedFuncionalidades(selectedItems)
        }

        return (
          <input
            type='checkbox'
            className={checkbox()}
            checked={table.getIsAllRowsSelected()}
            onChange={handleSelectAll}
          />
        )
      },
      cell: ({ row }) => {
        return (
          <input
            type='checkbox'
            className={checkbox()}
            checked={row.getIsSelected()}
            onChange={e => {
              row.getToggleSelectedHandler()(e)

              if (e.target.checked) {
                addFuncionalidade(row.original)
              } else {
                removeFuncionalidade(row.original)
              }
            }}
          />
        )
      }
    }),
    columnHelper.display({
      id: 'id',
      header: t`Nome da Permissão`,
      cell: ({ row: { original: funcionalidade } }) => {
        return <p className={'font-bold'}>{funcionalidade.nome}</p>
      }
    }),
    columnHelper.display({
      id: 'tipoAcesso',
      header: t`Tipo de Acesso`,
      cell: ({ row: { original: funcionalidade } }) => {
        return (
          <p className={'font-bold'}>
            {funcionalidade?.tiposAcesso
              ?.map(tipoAcesso => formatNomeTipoAcesso(tipoAcesso?.nome ?? ''))
              .join(', ')}
          </p>
        )
      }
    })
  ]
}
